export default {
      id: "ic-search-white-usage",
      viewBox: "0 0 48 48",
      url: "/" + "images/icons.3.109.2.svg#ic-search-white-usage",
      toString: function () {
        return this.url;
      }
    }